import axiosInstance from "@/api/axios-instance";
import { ConsentFormStatus } from "@/pages/users/types/user";

export async function getUsers({
  page,
  search,
  is_lead,
  product_id,
  hrc_status,
  mc_status,
  region,
}: {
  page: number;
  search?: string;
  is_lead?: boolean;
  product_id?: string;
  hrc_status?: ConsentFormStatus;
  mc_status?: ConsentFormStatus;
  region?: string;
}) {
  const response = await axiosInstance.get("/users", {
    params: {
      page,
      search,
      is_lead,
      product_id,
      hrc_status,
      mc_status,
      region,
    },
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("users is not loaded");
  }

  const {
    users,
    nextPage,
    lastPage,
    page: currentPage,
    total,
  } = response.data;
  return {
    users,
    nextPage,
    lastPage,
    currentPage,
    total,
  };
}
